import { CategoryMultiSelect } from './CategoryMultiSelect';
import { MoneyViewToggle } from './MoneyViewToggle';
import { PeriodFilter } from './PeriodFilter';
import { ResetButton } from './ResetButton';
import { SupplierMultiSelect } from './SupplierMultiSelect';
import { TransactionCounter } from './TransactionCounter';

/**
 * Barra de filtros globais sticky abaixo do AppHeader.
 * Layout horizontal, scroll horizontal em viewports estreitos.
 */
export function GlobalFilters() {
  return (
    <div className="aiobi-global-filters" role="toolbar" aria-label="Filtros globais">
      <div className="aiobi-global-filters__row">
        <PeriodFilter />
        <SupplierMultiSelect />
        <CategoryMultiSelect />
        <MoneyViewToggle />
      </div>
      <div className="aiobi-global-filters__tail">
        <TransactionCounter />
        <ResetButton />
      </div>
    </div>
  );
}
